import instance from "./instance";
export const findAll = () => {
    return instance.get(`/realisations`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
};
